import { useState } from 'react'
import { Winter, Autumn, Summer, Spring } from '../ui/elements/japanguide'

const seasons = [
  {
    name: 'חורף',
    color: '#006EBD',
    icon: Winter,
    places: [
      {
        name: 'סאפורו',
        desc: 'סאפורו היא עיר בצפון יפן, המפורסמת בפסטיבל השלג שלה. בחורף, העיר מתמלאת בפסלי שלג וקרח מרהיבים, וזה זמן מצוין ליהנות מהאווירה החגיגית והקסומה של הפסטיבל.',
      },
      {
        name: 'הוקאידו',
        desc: 'הוקאידו הוא האי הצפוני ביותר של יפן, המפורסם בנופים המושלגים שלו ובאתרי הסקי שלו. בחורף, זה זמן מצוין ליהנות מסקי, סנובורד וטיולים בשלג.',
      },
      {
        name: 'שירקאווה-גו',
        desc: 'שירקאווה-גו הוא כפר מסורתי יפהפייה, המפורסם בבתי הגג המשולשים שלו. בחורף, הכפר מתכסה בשלג, וזה זמן מצוין ליהנות מהאווירה השלווה והקסומה של הכפר.',
      },
    ],
  },
  {
    name: 'אביב',
    color: '#BD0029',
    icon: Autumn,
    places: [
      {
        name: 'טוקיו',
        desc: 'טוקיו היא עיר הבירה של יפן והיא מציעה שילוב מרתק של מסורת ומודרניות. באביב, העיר מתמלאת בפריחת הדובדבן המפורסמת, וזה זמן מצוין לטייל בפארקים ובגנים היפים של העיר.',
      },
      {
        name: 'קיוטו',
        desc: 'קיוטו היא עיר יפהפייה, שנחשבת למרכז התרבות של יפן. באביב, העיר פורחת ומתמלאת בצבעים, וזה זמן מצוין לבקר במקדשים ובאתרים ההיסטוריים שלה.',
      },
      {
        name: 'נארה',
        desc: 'נארה היא עיר קטנה וחמודה, המפורסמת בלהקות הצבאים המשוטטות בה חופשי. באביב, הצבאים משחקים ונהנים מהפריחה, וזה זמן מצוין לבקר בפארק נארה.',
      },
    ],
  },
  {
    name: 'סתיו',
    color: '#ADCEFF',
    icon: Spring,
    places: [
      {
        name: 'ניקו',
        desc: 'ניקו היא עיר הררית יפהפייה, המפורסמת במקדשים ובטבע שלה. בסתיו, העצים נצבעים בצבעים מרהיבים, וזה זמן מצוין ליהנות מהנופים המדהימים שלה.',
      },
      {
        name: 'הקונה',
        desc: 'הקונה היא עיירת נופש פופולרית, הממוקמת למרגלות הר פוג׳י. בסתיו, זה זמן מצוין לטיולים, רחצה במעיינות חמים ונופים מדהימים של הר פוג׳י.',
      },
      {
        name: 'קאנאזאווה',
        desc: 'קאנאזאווה היא עיר היסטורית יפהפייה, המפורסמת בגנים שלה. בסתיו, העצים נצבעים בצבעים מרהיבים, וזה זמן מצוין לטייל בגנים וליהנות מהאווירה השלווה.',
      },
    ],
  },
  {
    name: 'קיץ',
    color: '#FFD500',
    icon: Summer,
    places: [
      {
        name: 'אוסקה',
        desc: 'אוסקה היא עיר גדולה ותוססת, המפורסמת בחיי הלילה הסוערים והאוכל שלה. בקיץ, העיר מלאה בפסטיבלים ואירועים, וזה זמן מצוין ליהנות מהאווירה השמחה שלה.',
      },
      {
        name: 'הירושימה',
        desc: 'הירושימה היא עיר יפהפייה ומלאת חיים. בקיץ, העיר מלאה בפרחים וצמחייה, וזה זמן מצוין לבקר באנדרטת השלום ובפארקים.',
      },
      {
        name: 'אוקינאווה',
        desc: 'אוקינאווה היא קבוצת איים טרופיים בדרום יפן. בקיץ, זה הזמן האידיאלי ליהנות משחייה, שנורקלינג וגלישה במים הצלולים.',
      },
    ],
  },
]

export function SeasonsSelector() {
  const [activeSeason, setActiveSeason] = useState('חורף')

  const season = seasons.find((s) => s.name === activeSeason)

  return (
    <div className="flex flex-col gap-8 items-center text-white">
      <div className="flex gap-12">
        {seasons.map((s) => (
          <button
            key={s.name}
            onClick={() => setActiveSeason(s.name)}
            className={`flex flex-col items-center transition-transform duration-300 ${
              activeSeason === s.name ? 'scale-110' : 'scale-100'
            }`}
          >
            <span className="text-4xl">
              {typeof s.icon === 'string' ? (
                <span
                  className={
                    activeSeason === s.name ? s.color : 'text-[#5B5B5B]'
                  }
                >
                  {s.icon}
                </span>
              ) : (
                <s.icon color={activeSeason === s.name ? s.color : undefined} />
              )}
            </span>
            <h3
              className={`text-lg ${
                activeSeason === s.name ? 'text-white' : 'text-[#5B5B5B]'
              }`}
            >
              {s.name}
            </h3>
          </button>
        ))}
      </div>

      <div className="text-center p-4 text-white max-w-[1300px] h-20 flex flex-col lg:flex-row gap-16">
        {season.places.map((place) => (
          <div key={place.name} className="flex flex-col gap-3">
            <h3 className="text-2xl text-primary">{place.name}</h3>
            <p>{place.desc}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
